const ERROR_100 = "#C34954";
const ERROR_80 = "#F45B69";
const ERROR_60 = "#F89DA5";
const ERROR_40 = "#FBBDC3";
const ERROR_20 = "#FCD8DB";

const errorMetricsColors = {
  ERROR_100,
  ERROR_80,
  ERROR_60,
  ERROR_40,
  ERROR_20
};

export default errorMetricsColors;
